(function () {
  function getMediaId(thumb) {
    return thumb && thumb.getAttribute('data-media-id') || '';
  }

  function normalize(value) {
    return String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function getThumbText(thumb) {
    if (!thumb) return '';
    var img = thumb.querySelector('img');
    var link = thumb.querySelector('a');
    return [
      thumb.getAttribute('data-variant-id'),
      thumb.getAttribute('data-variant'),
      thumb.getAttribute('data-option'),
      thumb.getAttribute('data-value'),
      thumb.getAttribute('title'),
      thumb.getAttribute('aria-label'),
      link && link.getAttribute('title'),
      link && link.getAttribute('aria-label'),
      img && img.getAttribute('alt'),
      img && img.getAttribute('title'),
      img && img.getAttribute('src')
    ].filter(Boolean).join(' ');
  }

  function getRealThumb(productView, mediaId) {
    if (!mediaId) return null;
    var escaped = window.CSS && CSS.escape ? CSS.escape(mediaId) : mediaId.replace(/"/g, '\\"');
    return productView.querySelector('.productView-thumbnail-wrapper .productView-thumbnail[data-media-id="' + escaped + '"]');
  }

  function getCurrentMediaId(productView) {
    var currentThumb = productView.querySelector('.productView-thumbnail.slick-current, .productView-thumbnail.is-active');
    if (currentThumb) return getMediaId(currentThumb);

    var currentImage = productView.querySelector('.productView-nav .slick-current .productView-img-container[data-media-id], .productView-nav .slick-current [data-media-id]');
    return currentImage ? currentImage.getAttribute('data-media-id') : '';
  }

  function getProductData(productView) {
    if (productView.__capsuleProductData !== undefined) return productView.__capsuleProductData;

    var scripts = Array.from(document.querySelectorAll('script[type="application/json"], script:not([src])'));
    for (var i = 0; i < scripts.length; i += 1) {
      var text = (scripts[i].textContent || '').trim();
      if (!text || text.indexOf('"variants"') === -1) continue;

      try {
        var json = JSON.parse(text);
        if (json && Array.isArray(json.variants)) {
          productView.__capsuleProductData = json;
          return json;
        }
      } catch (error) {}

      try {
        var objectStart = text.indexOf('{');
        var objectEnd = text.lastIndexOf('}');
        if (objectStart !== -1 && objectEnd > objectStart) {
          var looseJson = JSON.parse(text.slice(objectStart, objectEnd + 1));
          if (looseJson && Array.isArray(looseJson.variants)) {
            productView.__capsuleProductData = looseJson;
            return looseJson;
          }
          if (looseJson && looseJson.product && Array.isArray(looseJson.product.variants)) {
            productView.__capsuleProductData = looseJson.product;
            return looseJson.product;
          }
        }
      } catch (error) {}
    }

    var windowKeys = Object.keys(window).slice(0, 700);
    for (var keyIndex = 0; keyIndex < windowKeys.length; keyIndex += 1) {
      try {
        var value = window[windowKeys[keyIndex]];
        if (value && Array.isArray(value.variants)) {
          productView.__capsuleProductData = value;
          return value;
        }
        if (value && value.product && Array.isArray(value.product.variants)) {
          productView.__capsuleProductData = value.product;
          return value.product;
        }
      } catch (error) {}
    }

    productView.__capsuleProductData = null;
    return null;
  }

  function variantMediaId(variant) {
    if (!variant) return '';
    if (variant.featured_media && variant.featured_media.id) return String(variant.featured_media.id);
    if (variant.featured_image && variant.featured_image.id) return String(variant.featured_image.id);
    if (variant.image_id) return String(variant.image_id);
    return '';
  }

  function variantImageText(variant) {
    if (!variant) return '';
    return normalize([
      variant.featured_image && variant.featured_image.src,
      variant.featured_image && variant.featured_image.url,
      variant.image,
      variant.image_url,
      variant.title,
      variant.option1,
      variant.option2,
      variant.option3,
      Array.isArray(variant.options) ? variant.options.join(' ') : ''
    ].filter(Boolean).join(' '));
  }

  function findVariantByMedia(productView, mediaId, thumb) {
    var product = getProductData(productView);
    if (!product || !Array.isArray(product.variants) || !mediaId) return null;

    var byMedia = product.variants.find(function (variant) {
      return variantMediaId(variant) === String(mediaId);
    });
    if (byMedia) return byMedia;

    var thumbText = normalize(getThumbText(thumb || getRealThumb(productView, mediaId)));
    if (!thumbText) return null;

    var byImage = product.variants.find(function (variant) {
      var imageText = variantImageText(variant);
      return imageText && (thumbText.indexOf(imageText) !== -1 || imageText.indexOf(thumbText) !== -1);
    });
    if (byImage) return byImage;

    return product.variants.find(function (variant) {
      var options = Array.isArray(variant.options) ? variant.options : [variant.option1, variant.option2, variant.option3].filter(Boolean);
      return options.some(function (optionValue) {
        var option = normalize(optionValue);
        return option && thumbText.indexOf(option) !== -1;
      });
    }) || null;
  }

  function setNativeValue(element, value) {
    if (!element) return;
    element.value = value;
    element.dispatchEvent(new Event('input', { bubbles: true }));
    element.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function selectVariant(productView, variant) {
    if (!variant || !variant.id) return;

    var form = productView.querySelector('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
    var scope = productView || document;

    var options = Array.isArray(variant.options) ? variant.options : [variant.option1, variant.option2, variant.option3].filter(Boolean);

    options.forEach(function (optionValue) {
      if (!optionValue) return;
      var escapedValue = window.CSS && CSS.escape ? CSS.escape(optionValue) : String(optionValue).replace(/"/g, '\\"');
      var optionInput = scope.querySelector('input[type="radio"][value="' + escapedValue + '"], input[type="button"][value="' + escapedValue + '"]');
      var optionSelect = form && Array.from(form.querySelectorAll('select')).find(function (select) {
        return Array.from(select.options).some(function (option) { return option.value === optionValue || option.text === optionValue; });
      });

      if (optionInput && !optionInput.checked) {
        optionInput.click();
        optionInput.dispatchEvent(new Event('change', { bubbles: true }));
      } else if (optionSelect) {
        setNativeValue(optionSelect, optionValue);
      } else {
        var normalizedOption = normalize(optionValue);
        var clickable = Array.from(scope.querySelectorAll('label, button, a, [data-value], [data-option-value], [data-variant], .swatch, .swatch-element, .single-option-selector')).find(function (element) {
          var candidate = normalize([
            element.getAttribute('data-value'),
            element.getAttribute('data-option-value'),
            element.getAttribute('data-variant'),
            element.getAttribute('title'),
            element.getAttribute('aria-label'),
            element.textContent
          ].filter(Boolean).join(' '));
          return candidate && (candidate === normalizedOption || candidate.indexOf(normalizedOption) !== -1);
        });

        if (clickable) {
          clickable.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
          clickable.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });

    var idField = form && form.querySelector('select[name="id"], input[name="id"]');
    if (idField && String(idField.value) !== String(variant.id)) {
      setNativeValue(idField, String(variant.id));
    }
  }

  function syncVariantFromMedia(productView, mediaId, thumb) {
    var variant = findVariantByMedia(productView, mediaId, thumb);
    if (variant) selectVariant(productView, variant);
  }

  function fitThumbs(container, track) {
    if (!container || !track) return;

    var style = window.getComputedStyle(track);
    var gap = parseFloat(style.columnGap || style.gap || '6') || 6;
    var visible = window.matchMedia && window.matchMedia('(max-width: 767px)').matches ? 4 : 5;
    var available = track.clientWidth - (gap * (visible - 1));
    var size = Math.max(1, Math.floor(available / visible));

    container.style.setProperty('--capsule-thumb-size', size + 'px');
  }

  function updateArrows(track, container) {
    if (!track || !container) return;
    var prev = container.querySelector('.capsule-gallery-arrow-prev');
    var next = container.querySelector('.capsule-gallery-arrow-next');
    var max = Math.max(0, track.scrollWidth - track.clientWidth - 2);

    if (prev) prev.classList.toggle('is-disabled', track.scrollLeft <= 2);
    if (next) next.classList.toggle('is-disabled', track.scrollLeft >= max);
  }

  function syncActive(productView) {
    var currentId = getCurrentMediaId(productView);
    var thumbs = productView.querySelectorAll('.capsule-gallery-thumb');

    thumbs.forEach(function (thumb) {
      thumb.classList.toggle('is-active', getMediaId(thumb) === currentId);
    });

    var active = productView.querySelector('.capsule-gallery-thumb.is-active');
    var track = productView.querySelector('.capsule-gallery-thumbs-track');
    var container = productView.querySelector('.capsule-gallery-thumbs');
    fitThumbs(container, track);

    if (currentId && productView.__capsuleLastSyncedVariantMediaId !== currentId) {
      productView.__capsuleLastSyncedVariantMediaId = currentId;
      syncVariantFromMedia(productView, currentId, getRealThumb(productView, currentId));
    }

    if (active && track) {
      updateArrows(track, container);
    }
  }

  function isVideoMediaElement(element) {
    if (!element) return false;
    var text = [
      element.getAttribute('data-media-type'),
      element.getAttribute('data-media'),
      element.getAttribute('data-type'),
      element.getAttribute('aria-label'),
      element.getAttribute('title'),
      element.className,
      element.innerHTML
    ].filter(Boolean).join(' ').toLowerCase();

    return text.indexOf('video') !== -1
      || text.indexOf('youtube') !== -1
      || text.indexOf('vimeo') !== -1
      || text.indexOf('mp4') !== -1
      || !!element.querySelector('video, iframe[src*="youtube"], iframe[src*="vimeo"], .deferred-media, .deferred-media__poster-button, [data-media-type="video"], [data-media-type="external_video"]');
  }

  function isVideoMedia(productView, mediaId, thumb) {
    var realThumb = thumb || getRealThumb(productView, mediaId);
    if (isVideoMediaElement(realThumb)) return true;

    if (mediaId) {
      var escaped = window.CSS && CSS.escape ? CSS.escape(mediaId) : String(mediaId).replace(/"/g, '\\"');
      var media = productView.querySelector('[data-media-id="' + escaped + '"], [data-media-id="' + escaped + '"] *');
      if (isVideoMediaElement(media && media.closest('[data-media-id]') || media)) return true;
    }

    return false;
  }

  function activateThumb(productView, mediaId) {
    var realThumb = getRealThumb(productView, mediaId);
    var realLink = realThumb && realThumb.querySelector('.productView-thumbnail-link');

    if (realLink) {
      realLink.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
    } else if (realThumb) {
      realThumb.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
    }

    window.setTimeout(function () { syncVariantFromMedia(productView, mediaId, realThumb); }, 60);
    setTimeout(function () { syncActive(productView); }, 80);
    setTimeout(function () { syncActive(productView); }, 350);
  }

  function addArrow(container, direction, track) {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'capsule-gallery-arrow capsule-gallery-arrow-' + direction;
    button.setAttribute('aria-label', direction === 'prev' ? 'Ver miniaturas anteriores' : 'Ver miniaturas seguintes');
    button.innerHTML = direction === 'prev' ? '&#8249;' : '&#8250;';

    button.addEventListener('click', function () {
      var delta = Math.max(120, track.clientWidth);
      var max = Math.max(0, track.scrollWidth - track.clientWidth);
      var target = direction === 'prev'
        ? Math.max(0, track.scrollLeft - delta)
        : Math.min(max, track.scrollLeft + delta);

      track.scrollTo({ left: target, behavior: 'smooth' });
      window.setTimeout(function () { updateArrows(track, container); }, 260);
    });

    container.appendChild(button);
  }

  function buildThumbnails(productView) {
    var imagesWrapper = productView.querySelector('.productView-images-wrapper');
    var mainGallery = productView.querySelector('.productView-nav');
    var sourceThumbs = productView.querySelector('.productView-thumbnail-wrapper.is-hidden-mobile .productView-for')
      || productView.querySelector('.productView-thumbnail-wrapper.is-hidden-desktop .productView-for')
      || productView.querySelector('.productView-for');

    if (!imagesWrapper || !mainGallery || !sourceThumbs) return;

    var originalThumbs = Array.from(productView.querySelectorAll('.productView-thumbnail[data-media-id]:not(.slick-cloned)'));
    if (!originalThumbs.length) {
      originalThumbs = Array.from(sourceThumbs.querySelectorAll('.productView-thumbnail[data-media-id]:not(.slick-cloned)'));
    }

    originalThumbs = originalThumbs
      .map(function (thumb, index) {
        var slickIndex = parseInt(thumb.getAttribute('data-slick-index'), 10);
        return {
          thumb: thumb,
          order: Number.isFinite(slickIndex) && slickIndex >= 0 ? slickIndex : index + 10000
        };
      })
      .filter(function (item) {
        return item.order >= 0;
      })
      .sort(function (a, b) {
        return a.order - b.order;
      })
      .map(function (item) {
        return item.thumb;
      });

    var seen = {};
    originalThumbs = originalThumbs.filter(function (thumb) {
      var id = getMediaId(thumb);
      if (!id || seen[id]) return false;
      seen[id] = true;
      return true;
    });

    if (!originalThumbs.length) return;

    var existing = imagesWrapper.querySelector('.capsule-gallery-thumbs');
    if (!existing) {
      existing = document.createElement('div');
      existing.className = 'capsule-gallery-thumbs';
      mainGallery.insertAdjacentElement('afterend', existing);
    }

    var signature = originalThumbs.map(getMediaId).join('|');
    if (existing.getAttribute('data-signature') === signature && existing.querySelector('.capsule-gallery-thumb')) {
      syncActive(productView);
      return;
    }

    existing.setAttribute('data-signature', signature);
    existing.innerHTML = '';

    var track = document.createElement('div');
    track.className = 'capsule-gallery-thumbs-track';

    originalThumbs.forEach(function (thumb) {
      var clone = thumb.cloneNode(true);
      clone.className = 'capsule-gallery-thumb';
      clone.setAttribute('data-media-id', getMediaId(thumb));
      clone.removeAttribute('style');
      clone.addEventListener('click', function (event) {
        event.preventDefault();
        activateThumb(productView, getMediaId(clone));
      });
      track.appendChild(clone);
    });

    existing.appendChild(track);
    addArrow(existing, 'prev', track);
    addArrow(existing, 'next', track);
    fitThumbs(existing, track);
    track.addEventListener('scroll', function () {
      window.requestAnimationFrame(function () { updateArrows(track, existing); });
    }, { passive: true });
    updateArrows(track, existing);
    syncActive(productView);
  }

  function initProductTabVideos() {
    document.querySelectorAll('.capsule-product-video-tab__frame video, .capsule-video-box video, video.capsule-video').forEach(function (video) {
      if (video.__capsuleVideoTabBound) return;
      video.__capsuleVideoTabBound = true;

      var frame = video.closest('.capsule-video-box, .capsule-product-video-tab__frame, .capsule-video-frame') || video.parentElement;
      if (frame && window.getComputedStyle(frame).position === 'static') {
        frame.style.position = 'relative';
      }

      video.removeAttribute('controls');
      video.controls = false;
      video.muted = true;
      video.autoplay = true;
      video.loop = true;
      video.playsInline = true;

      if (typeof video.play === 'function') {
        video.play().catch(function () {});
      }

      if (!frame) return;

      var controls = frame.querySelector('.capsule-video-controlbar');
      if (!controls) {
        controls = document.createElement('div');
        controls.className = 'capsule-video-controlbar';

        var playButton = document.createElement('button');
        playButton.type = 'button';
        playButton.className = 'capsule-video-control';
        playButton.setAttribute('data-action', 'play');
        playButton.setAttribute('aria-label', 'Pausar video');

        var soundButton = document.createElement('button');
        soundButton.type = 'button';
        soundButton.className = 'capsule-video-control';
        soundButton.setAttribute('data-action', 'sound');
        soundButton.setAttribute('aria-label', 'Ativar som');

        var progress = document.createElement('button');
        progress.type = 'button';
        progress.className = 'capsule-video-progress';
        progress.setAttribute('aria-label', 'Progresso do video');
        progress.innerHTML = '<span class="capsule-video-progress-fill"></span>';

        var fullscreenButton = document.createElement('button');
        fullscreenButton.type = 'button';
        fullscreenButton.className = 'capsule-video-control';
        fullscreenButton.setAttribute('data-action', 'fullscreen');
        fullscreenButton.setAttribute('aria-label', 'Ver em ecra inteiro');

        controls.appendChild(playButton);
        controls.appendChild(soundButton);
        controls.appendChild(progress);
        controls.appendChild(fullscreenButton);
        frame.appendChild(controls);
      }

      var hideTimer = null;
      var playControl = controls.querySelector('[data-action="play"]');
      var soundControl = controls.querySelector('[data-action="sound"]');
      var progressControl = controls.querySelector('.capsule-video-progress');
      var progressFill = controls.querySelector('.capsule-video-progress-fill');
      var fullscreenControl = controls.querySelector('[data-action="fullscreen"]');

      function syncPlayState() {
        if (!playControl) return;
        playControl.classList.toggle('is-paused', video.paused);
        playControl.setAttribute('aria-label', video.paused ? 'Reproduzir video' : 'Pausar video');
      }

      function syncSoundState() {
        if (!soundControl) return;
        soundControl.classList.toggle('is-muted', video.muted || video.volume === 0);
        soundControl.setAttribute('aria-label', video.muted || video.volume === 0 ? 'Ativar som' : 'Desativar som');
      }

      function syncProgress() {
        if (!progressFill || !video.duration || Number.isNaN(video.duration)) return;
        var percent = Math.max(0, Math.min(100, (video.currentTime / video.duration) * 100));
        progressFill.style.width = percent + '%';
        if (progressControl) progressControl.setAttribute('aria-valuenow', Math.round(percent));
      }

      function showControls() {
        frame.classList.add('is-controls-visible');
        window.clearTimeout(hideTimer);
        hideTimer = window.setTimeout(function () {
          frame.classList.remove('is-controls-visible');
        }, 3600);
      }

      function requestFullscreen() {
        showControls();
        var target = frame;
        var request = target.requestFullscreen
          || target.webkitRequestFullscreen
          || target.msRequestFullscreen
          || target.mozRequestFullScreen;

        if (request) {
          request.call(target);
          return;
        }

        if (typeof video.webkitEnterFullscreen === 'function') {
          video.webkitEnterFullscreen();
        }
      }

      video.addEventListener('click', showControls);
      video.addEventListener('touchstart', showControls, { passive: true });
      video.addEventListener('play', syncPlayState);
      video.addEventListener('pause', syncPlayState);
      video.addEventListener('volumechange', syncSoundState);
      video.addEventListener('timeupdate', syncProgress);
      video.addEventListener('loadedmetadata', syncProgress);

      if (playControl) {
        playControl.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          showControls();

          if (video.paused) {
            video.play().catch(function () {});
          } else {
            video.pause();
          }

          syncPlayState();
        });
      }

      if (soundControl) {
        soundControl.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          showControls();

          video.muted = !video.muted;
          if (!video.muted && video.volume === 0) video.volume = 1;
          syncSoundState();
        });
      }

      if (progressControl) {
        progressControl.setAttribute('role', 'slider');
        progressControl.setAttribute('aria-valuemin', '0');
        progressControl.setAttribute('aria-valuemax', '100');
        progressControl.setAttribute('aria-valuenow', '0');

        progressControl.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          showControls();

          if (!video.duration || Number.isNaN(video.duration)) return;

          var rect = progressControl.getBoundingClientRect();
          var ratio = Math.max(0, Math.min(1, (event.clientX - rect.left) / rect.width));
          video.currentTime = ratio * video.duration;
          syncProgress();
        });
      }

      if (fullscreenControl) {
        fullscreenControl.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          requestFullscreen();
        });
      }

      syncPlayState();
      syncSoundState();
      syncProgress();
    });
  }

  function boot() {
    document.querySelectorAll('.productView').forEach(function (productView) {
      buildThumbnails(productView);

      var mainGallery = productView.querySelector('.productView-nav');
      if (mainGallery && !mainGallery.__capsuleGalleryBound) {
        mainGallery.__capsuleGalleryBound = true;
        mainGallery.addEventListener('click', function () {
          setTimeout(function () { syncActive(productView); }, 120);
        });
      }
    });

    initProductTabVideos();
  }

  function schedule() {
    boot();
    setTimeout(boot, 300);
    setTimeout(boot, 900);
    setTimeout(boot, 1800);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }

  setInterval(function () {
    document.querySelectorAll('.productView').forEach(syncActive);
  }, 800);

  window.addEventListener('resize', function () {
    window.clearTimeout(window.__capsuleGalleryResizeTimer);
    window.__capsuleGalleryResizeTimer = window.setTimeout(schedule, 150);
  });

  window.addEventListener('orientationchange', function () {
    window.clearTimeout(window.__capsuleGalleryResizeTimer);
    window.__capsuleGalleryResizeTimer = window.setTimeout(schedule, 250);
  });
})();
